import gql from 'graphql-tag'

export const GET_ORDER_LIST_PRINT = gql`
  query (
    $perPage: Int
    $page: Int
    $ids: [ID!]
    $orderStatus: OrderFilterEnum
    $dateType: OrderQueryDateTypeEnum
    $startDate: Time
    $endDate: Time
    $startTime: Time
    $endTime: Time
  ) {
    orderList(
      perPage: $perPage
      page: $page
      ids: $ids
      orderStatus: $orderStatus
      dateType: $dateType
      startDate: $startDate
      endDate: $endDate
      startTime: $startTime
      endTime: $endTime
    ) {
      nodes {
        id
        name
        price
        quantity
        barcode
        orderBank
        address
        tel
        taxInvoice
        storefrontChangeMoney
        storefrontReceiveMoney
        marketplaceDiscount
        marketplaceId
        promoCodeDiscount
        shipFromName
        shipFromAddress
        taxId
        tag
        annotation
        contactMethod
        invoiceNumber
        closedNote
        shippopTrackingCode
        shippingSortingCode
        shippingType
        printerName
        paymentByName
        customer {
          id
          tagList
        }
        stock {
          id
          name
          tel
          taxId
          address
          orderNumberPrefix
        }
        shop {
          id
          taxId
          tel
        }
        reseller {
          id
          tel
          rewardValue
          resellerAddress
        }
        promoCode {
          id
          code
        }
        orderDiscount
        shippingFee
        purchases {
          id
          name
          price
          quantity
          discount
          pictureUrl
        }
        setPurchases {
          id
          name
          price
          quantity
          pictureUrl
        }
        shop {
          id
          shopurl
          facebookPageId
          facebookPages
        }
        createdAt
        transferredAt
        taxInvoiceDate
        printedAt
        markTransferredAt
        closedAt
      }
    }
  }
`

export default {
  GET_ORDER_LIST_PRINT
}
